// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ReportTotalsSchema } from './v1/reportTotalsSchema';

export const getReportsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const getReportsQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Start date for the report period (ISO 8601 format: YYYY-MM-DD)")),
  until: z.optional(z.string().date().describe("End date for the report period (ISO 8601 format: YYYY-MM-DD)")),
  user_ids: z.optional(z.coerce.string().describe("Comma-separated list of user IDs to filter by")),
  project_ids: z.optional(z.coerce.string().describe("Comma-separated list of project IDs to filter by")),
  client_ids: z.optional(z.coerce.string().describe("Comma-separated list of client IDs to filter by")),
}).optional();

export const getReportsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Report totals retrieved successfully
 */
export const getReports200Schema = z.array(z.lazy(() => v1ReportTotalsSchema));

export const getReportsQueryResponseSchema = z.lazy(() => getReports200Schema);
